export const MailValidationRegex = /^[^ ;:#*@]+@[^ ;:#*@_]+(\.[A-Za-z]{2,})+$/
